import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {
    eventCzpromote, eventsDayRegistrationAndCheckinCountStats, eventFormQuestionStatistics, eventFormStatistics, eventForm,eventCheckinForm,
    eventCiFormPreset, event,eventExp,eventSimples,eventRateLimit,eventSimple, eventTicketingEnable, eventTicketingDisable, events,
    eventCreate, eventPublish, eventTicketing, eventTicketings, eventAgenda, eventAgendas, eventConfig,eventCheckinCredit,eventCheckinCredits,eventCheckinCreditsExp, eventHeader,
    eventDuplicate, eventGuest, eventGuests,guestGroups,guestGroup,guestGroupEvents, guestGroupEventExp,eventPoster, eventPosters,eventVideos, eventAttendees, eventQrcodeLogo,uniqueField,
    eventNumCount, eventRecover, operationEvents,shareConfig,eventImages,eventImagesBatch,eventDiploma,eventDiplomaExp,eventWxLevelShare,eventWxLevelShareExp,eventWxLevelShareStatis,
    eventCodeShares,eventCodeShare,eventCodeShareImp,eventCodeShareExp,eventCodeShareTemplate,eventGroups,eventGroup,eventGroupShare,
    eventComments,eventComment,eventCommentPages,evtFeedbackShow} = api


export async function findEventNumCount(params) {
    return request({url: eventNumCount, method: 'get', data: params})
}

export async function findEventDayByRegistrationAndCheckinCountStats(params) {
    return request({url: eventsDayRegistrationAndCheckinCountStats, method: 'get', data: params,})
}

/**
 * 获取报名表单预定义项
 */
export async function findEventCiFormPreset(params) {
    return request({url: eventCiFormPreset, method: 'get', data: params,})
}

/**
 * 获取报名表单统计
 */
export async function findEventCiFormStatistics(params) {
    return request({url: eventFormStatistics, method: 'get', data: params,})
}

/**
 * 报名表单
 */
export async function findEventCiForm(params) {
    return request({url: eventForm, method: 'get', data: params,})
}

/**
 * 获取报名表单问题统计
 */
export async function findEventCiFormQuestionStatistics(params) {
    return request({url: eventFormQuestionStatistics, method: 'get', data: params,})
}

/**
 * 更新报名表单
 */
export async function updateEventCiForm(params) {
    return request({url: eventForm, method: 'put', data: params,})
}

/**
 * 更新报名表单
 */
export async function updateEventCheckinForm(params) {
    return request({url: eventCheckinForm, method: 'put', data: params,})
}


/**
 * 查找活动
 */
export async function findEvent(params) {
    return request({url: event, method: 'get', data: params,})
}

export async function findEventSomple(params) {
    return request({url: eventSimple, method: 'get', data: params,})
}
export async function findEventSomples(params) {
    return request({url: eventSimples, method: 'get', data: params,})
}
export async function findEventRateLimit(params) {
    return request({url: eventRateLimit, method: 'get', data: params,})
}
export async function expEvents(params) {
    return request({url: eventExp, method: 'get', data: params,})
}


/**
 * 查找活动,会增加浏览数
 */
export async function findEventWithViewedCounted(params) {
    return request({url: event, method: 'get', data: Object.assign(params, {viewedCounted: true}),})
}


/**
 * 创建活动
 */
export async function createEvent(params) {

    return request({url: eventCreate, method: 'post', data: params,})
}

/**
 * 复制活动
 */
export async function duplicateEvent(params) {
    return request({url: eventDuplicate, method: 'post', data: params,})
}


/**
 * 发布活动
 */
export async function publishEvent(params) {
    return request({url: eventPublish, method: 'post', data: params,})
}


/**
 * 更新活动
 */
export async function updateEvent(params) {
    return request({url: event, method: 'put', data: params,})
}

/**
 * 查询基本信息
 */
export async function findEventHeader(params) {
    return request({url: eventHeader, method: 'get', data: params,})
}

/**
 * 更新活动基本信息
 */
export async function updateEventHeader(params) {
    return request({url: eventHeader, method: 'put', data: params,})
}

export async function patchEventHeader(params) {
    return request({url: eventHeader, method: 'patch', data: params,})
}

/**
 * 更新活动配置信息
 */
export async function findEventConfig(params) {
    return request({url: eventConfig, method: 'get', data: params,})
}

export async function updateEventConfig(params) {
    return request({url: eventConfig, method: 'put', data: params,})
}

export async function patchEventConfig(params) {
    return request({url: eventConfig, method: 'patch', data: params,})
}

export async function updateEventPromote(params) {
    return request({url: eventCzpromote, method: 'post', data: params,})
}

/**
 * 更新活动嘉宾
 */
export async function updateEventGuest(params) {
    return request({url: eventGuest, method: 'put', data: params,})
}

export async function patchEventGuests(params) {
    return request({url: eventGuests, method: 'patch', data: params,})
}
export async function findGuestGroups(params) {
    return request({url: guestGroups, method: 'get', data: params,})
}
export async function createGuestGroups(params) {
    return request({url: guestGroups, method: 'post', data: params,})
}
export async function updateGuestGroup(params) {
    return request({url: guestGroup, method: 'put', data: params,})
}
export async function deleteGuestGroup(params) {
    return request({url: guestGroup, method: 'delete', data: params,})
}
export async function findGuestGroupEvents(params) {
    return request({url: guestGroupEvents, method: 'get', data: params,})
}
export async function expGuestGroupEvents(params) {
    return request({url: guestGroupEventExp, method: 'get', data: params,})
}

/**
 * 更新活动流程
 */
export async function updateEventAgenda(params) {
    return request({url: eventAgenda, method: 'put', data: params,})
}

export async function patchEventAgendas(params) {
    return request({url: eventAgendas, method: 'patch', data: params,})
}

/**
 * 更新活动票种
 */
export async function updateEventTicketing(params) {
    return request({url: eventTicketing, method: 'put', data: params,})
}

export async function patchEventTicketings(params) {
    return request({url: eventTicketings, method: 'patch', data: params,})
}

export async function fintEventTicketings(params) {
    return request({url: eventTicketings, method: 'get', data: params,})
}


/**
 * 打开活动票种
 */
export async function enableEventTicketing(params) {
    return request({url: eventTicketingEnable, method: 'post', data: params,})
}


/**
 * 关闭活动票种
 */
export async function disableEventTicketing(params) {
    return request({url: eventTicketingDisable, method: 'post', data: params,})
}


/**
 * 更新活动海报
 */
export async function updateEventPoster(params) {
    return request({url: eventPoster, method: 'put', data: params,})
}

export async function patchEventPosters(params) {
    return request({url: eventPosters, method: 'patch', data: params,})
}
/**
 * 更新活动视频
 */
export async function patchEventVideos(params) {
    return request({url: eventVideos, method: 'patch', data: params,})
}

/**
 * 更新活动二维码logo
 */
export async function updateEventQrcodeLogo(params) {
    return request({url: eventQrcodeLogo, method: 'post', data: params,})
}


/**
 * 删除活动
 */
export async function deleteEvent(params) {
    return request({url: event, method: 'delete', data: params,})
}

/**
 * 删除活动
 */
export async function recoverEvent(params) {
    return request({url: eventRecover, method: 'put', data: params,})
}


/**
 * 查找活动列表
 */
export async function findEvents(params) {
    return request({url: events, method: 'get', data: params,})
}

/**
 * 查找活动列表
 */
export async function findOperationEvents(params) {
    return request({url: operationEvents, method: 'get', data: params,})
}

/**
 * 删除活动
 */
export async function deleteEvents(params) {
    return request({url: events, method: 'delete', data: params,})
}
/**
 * 删除活动
 */
export async function findUniqueField(params) {
    return request({url: uniqueField, method: 'get', data: params,})
}
/**
 * 查询分享
 */
export async function findShareConfig(params) {
    return request({url: shareConfig, method: 'get', data: params,})
}
/**
 * 查询分享
 */
export async function updateShareConfig(params) {
    return request({url: shareConfig, method: 'post', data: params,})
}
/**
 * 查询邀请函图片
 */
export async function findEventImages(params) {
    return request({url: eventImages, method: 'get', data: params,})
}
export async function updateEventImages(params) {
    return request({url: eventImagesBatch, method: 'put', data: params,})
}
/**
 * 结业证书
 */
export async function findEventDiploma(params) {
    return request({url: eventDiploma, method: 'get', data: params,})
}
export async function updateEventDiploma(params) {
    return request({url: eventDiploma, method: 'put', data: params,})
}
export async function expEventDiploma(params) {
    return request({url: eventDiplomaExp, method: 'post', data: params,})
}
/**
 * 微信分享营销
 */
export async function findEventWxLevelShare(params) {
    return request({url: eventWxLevelShare, method: 'get', data: params,})
}
export async function expEventWxLevelShare(params) {
    return request({url: eventWxLevelShareExp, method: 'get', data: params,})
}
export async function findEventWxLevelShareStatis(params) {
    return request({url: eventWxLevelShareStatis, method: 'get', data: params,})
}
/**
 * 邀请码
 */
export async function findEvenCodeShares(params) {
    return request({url: eventCodeShares, method: 'get', data: params,})
}
export async function createEvenCodeShares(params) {
    return request({url: eventCodeShares, method: 'post', data: params,})
}
export async function updateEvenCodeShare(params) {
    return request({url: eventCodeShare, method: 'put', data: params,})
}
export async function deleteEvenCodeShares(params) {
    return request({url: eventCodeShares, method: 'delete', data: params,})
}
export async function deleteEvenCodeShare(params) {
    return request({url: eventCodeShare, method: 'delete', data: params,})
}
export async function impEvenCodeShare(params) {
    return request({url: eventCodeShareImp, method: 'post', data: params,})
}
export async function expEvenCodeShare(params) {
    return request({url: eventCodeShareExp, method: 'get', data: params,})
}
export async function findEvenCodeShareTemplate(params) {
    return request({url: eventCodeShareTemplate, method: 'get', data: params,})
}

/**
 * 签到积分
 */
export async function findEventCheckinCredit(params) {
    return request({url: eventCheckinCredit, method: 'get', data: params,})
}
export async function findEventCheckinCredits(params) {
    return request({url: eventCheckinCredits, method: 'get', data: params,})
}
export async function expEventCheckinCredits(params) {
    return request({url: eventCheckinCreditsExp, method: 'get', data: params,})
}
export async function updateEventCheckinCredita(params) {
    return request({url: eventCheckinCredit, method: 'put', data: params,})
}
/**
 * 活动分组
 */
export async function findEventGroups(params) {
    return request({url: eventGroups, method: 'get', data: params,})
}
export async function createEventGroups(params) {
    return request({url: eventGroups, method: 'post', data: params,})
}
export async function updateEventGroup(params) {
    return request({url: eventGroup, method: 'put', data: params,})
}
export async function deleteEventGroup(params) {
    return request({url: eventGroup, method: 'delete', data: params,})
}
export async function findEventGroupShare(params) {
    return request({url: eventGroupShare, method: 'get', data: params,})
}
export async function updateEventGroupShare(params) {
    return request({url: eventGroupShare, method: 'put', data: params,})
}

/**
 * 评论
 */
export async function findEventComments(params) {
    return request({url: eventComments, method: 'get', data: params,})
}
export async function createEventComments(params) {
    return request({url: eventComments, method: 'post', data: params,})
}
export async function findEventCommentPages(params) {
    return request({url: eventCommentPages, method: 'get', data: params,})
}
export async function updateEventComment(params) {
    return request({url: eventComment, method: 'put', data: params,})
}
export async function deleteEventComment(params) {
    return request({url: eventComment, method: 'delete', data: params,})
}

/**
 * 举报开关
 */
export async function updateEvtFeedbackShow(params) {
    return request({url: evtFeedbackShow+'?showFeedback='+params.showFeedback, method: 'put', data: params,})
}





// WEBPACK FOOTER //
// ./src/services/evt.js